const Twitter = ({
  color = "var(--primary500)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill={color} />
      <g clip-path="url(#clip0_6955_16160)">
        <path
          d="M4.17094 4H8.83375C10.1819 5.95969 11.5272 7.92156 12.8759 9.88125C14.565 7.9225 16.2494 5.95938 17.9378 4H19.3191C17.3747 6.25719 15.4334 8.51719 13.4897 10.7747C15.6025 13.85 17.7147 16.9259 19.8294 20H15.1672C13.7425 17.9303 12.3219 15.8578 10.8969 13.7881C9.11563 15.8591 7.33531 17.9309 5.55188 20H4.17156C6.20969 17.6322 8.2475 15.2644 10.2841 12.895C8.24625 9.93 6.21031 6.96375 4.17094 4ZM6.05094 5.03969C9.30656 9.69563 12.5609 14.3528 15.8169 19.0084C16.5238 19.0084 17.2306 19.0078 17.9375 19.0087C14.6834 14.3516 11.4278 9.69594 8.17219 5.04C7.465 5.03937 6.75781 5.03969 6.05094 5.03969Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6955_16160">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Twitter;
